<template>
	<sf-search-layout>
		<el-row :gutter="20">
			<el-col :span="4">
				<sf-select-group
					:label="getMessage_('SWCC000247')"
					:inputValue="plantCd_"
					:options="plants_"
					:onChange="value => onChange({ key: 'plantCd', value })"
				/>
			</el-col>
			<el-col :span="4">
				<sf-select-group
					:label="getMessage_('SWCC000255')"
					:inputValue="pgmId_"
					:options="pgmIds_"
					:onChange="value => onChange({ key: 'pgmId', value })"
				/>
			</el-col>
		</el-row>
		<template slot="button">
			<sf-button v-if="isButton_(scrId, 'CR')" line :onClick="findAllProcesses"
				><i class="icon-sf-search"></i>{{ getMessage_('SWCC000244') }}</sf-button
			>
		</template>
	</sf-search-layout>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@common/SyncManagement/store/helpers';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	computed: {
		...rootComputed,
		...serviceComputed
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		onChange({ key, value }) {
			this.DEFAULT_ASSIGN({
				key: 'searchParams',
				value: {
					...this.searchParams,
					[key]: value
				}
			});
		},
		findAllProcesses() {
			this.$sf_toggleLoading(true);
			this.fetchProcesses_({ plantCd: this.user.plantCd, urlSearchParams: this.urlSearchParams_ })
				.then(header => {
					this.$sf_toast({
						...this.$sf_setToastOption(header),
						message: this.getMessage_(header.messageCd) !== '' ? this.getMessage_(header.messageCd) : header.message
					});
				})
				.catch(error => {
					this.$sf_toast({ type: 'error', message: error.message });
				})
				.finally(() => this.$sf_toggleLoading(false));
		}
	},
	created() {
		this.$sf_toggleLoading(true);
		this.fetchPlants_()
			.then(() => this.fetchPgmIds_({ plantCd: this.user.plantCd }))
			.then(() => this.DEFAULT_ASSIGN({ key: 'searchParams', value: { ...this.searchParams, plantCd: this.user.plantCd } }))
			.then(() => this.getSyncFlagList_())
			.then(() => this.getDBInfoList_())
			.finally(() => this.$sf_toggleLoading(false));
	},
	watch: {
		pgmId_() {
			this.findAllProcesses();
		},
		langCd() {
			this.getSyncFlagList_();
			this.getDBInfoList_();
		}
	}
};
</script>

<style langType="scss"></style>
